import type { FormBlockContext } from './types';
import { createContext } from 'reka-ui';

export const [injectFormBlockContext, provideFormBlockContext] = createContext<FormBlockContext>('FormBlock');
